export function getPeriods() {
    return [
        { value: 'day', label: 'dziennie', name: 'dzienna' },
        { value: 'week', label: 'tydzień', name: 'tygodniowa' },
        { value: 'month', label: 'miesiąc', name: 'miesięczna' },
        { value: 'year', label: 'rok', name: 'roczna' },
    ];
}

export function getLabelForPeriod(id) {
    return getPeriods().find((x) => x.value === id)?.label;
}

export function getNameForPeriod(id) {
    return getPeriods().find((x) => x.value === id)?.name;
}